<div
  class="card"
  [style.border]="itemStyle().card.border"
  [style.boxShadow]="itemStyle().card.boxShadow"
  [style.background]="itemStyle().card.background"
  [style.borderRadius]="itemStyle().card.borderRadius"
>
  @let picture = stepContent().picture;
  <div class="step-visual">
    @let indicatorImage = stepContent().indicatorImage;
    @if (indicatorImage) {
      <img
        class="step-indicator"
        [src]="indicatorImage.imageUrl"
        [alt]="indicatorImage.alternativeText"
      />
    }
    <img
      class="step-img"
      [src]="picture.imageUrl"
      [alt]="picture.alternativeText"
    />
  </div>

  <div class="card-body">
    @let titleStyles = itemStyle().title;
    <p
      class="card-title"
      [style.color]="titleStyles.color"
      [style.fontFamily]="titleStyles.fontFamily"
      [innerHTML]="stepContent().title! | safe"
    ></p>
    @let descriptionStyles = itemStyle().description;
    <p
      class="card-text"
      [style.color]="descriptionStyles.color"
      [style.fontFamily]="descriptionStyles.fontFamily"
      [innerHTML]="stepContent().description | safe"
    ></p>
  </div>
</div>
